import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap'
import { DatePickerComponent } from './date-picker.component'
import { SvgModule } from '../../../shared/svg/svg.module'
import { ReactiveFormsModule } from '@angular/forms'

@NgModule({
  imports: [CommonModule, NgbDatepickerModule, SvgModule, ReactiveFormsModule],
  declarations: [DatePickerComponent],
  exports: [DatePickerComponent]
})
export class DatePickerModule {}
